import React from 'react';
import Radium from 'radium';

import ProductDesignThumbnail from 'views/product/ProductDesignThumbnail';

import InfiniteScroll from 'react-infinite-scroller';

import {Title} from 'views/AppElements';

import Slider from "react-slick";

const DEFAULT_SLIDER_SETTINGS = {
			  speed: 350,
		      infinite: false,
		      className: 'productSlider',
			  variableWidth: false,
			  cssEase: 'cubic-bezier(0.97, 0.99, 0.98, 0.97)',
		      slidesToShow: 4,
		      slidesToScroll: 1,
			  swipeToSlide: true,
			  swipe: true,
		      responsive: [{
					      	breakpoint: 900,
					      	settings: {
					            slidesToShow: 2,
								slidesToScroll: 1,
								variableWidth: true
								
					          }
					      },
					      {
					      	breakpoint: 600,
					          settings: {
					            slidesToShow: 1,
								slidesToScroll: 1,
								variableWidth: true,
								
					          }
					      }
		      ]
		    };


class ProductSlider extends React.Component {
	componentDidUpdate() {
		//start from first slide on every update
		this.slide.slickGoTo(0);
	}

	render() {
		const settings = Object.assign({}, DEFAULT_SLIDER_SETTINGS);

		if(this.props.productViewMode === 'both')
			settings.slidesToShow = 1;

		settings.dots = this.props.navigator === 'dots';
		settings.arrows = this.props.navigator === 'arrows';
		settings.autoplay = this.props.autoplay;
		settings.infinite = this.props.infinite;

		return <div className="productSlider" id={this.props.id}>
				<Title title={this.props.title} />
					
				<Slider {...settings} ref={r => this.slide=r}>
					{this.props.children}
				</Slider>
			</div>;
	}
}

ProductSlider = Radium(ProductSlider);


class ProductList extends React.Component {
	loadFunc() {
		if(this.props.loadMore)
			this.props.loadMore();
	}


	getProducts() {
		const products = this.props.products;

		if(products == null)
			return null;

		if(this.props.flattenProductImages === true) {

			let multiProducts = [];
			for(var i in products) {
				const product = products[i];

				if(product.productImages.length > 1) {
					const eachImgProducts = product.productImages.map(pImg => {
						const productClone = JSON.parse(JSON.stringify(product));
						productClone.productImages = [pImg];
						return productClone;
					});

					multiProducts = multiProducts.concat(eachImgProducts);
				} else {
					multiProducts.push(product);
				}
			}

			return multiProducts;
		}

		return products;
	}

	render() {
		const title = this.props.title;
		const hasMore = this.props.hasMore || false;
		const products = this.getProducts();

		const productViewMode = this.props.productViewMode;

		const loadMoreLoader = <div key={0} style={{fontSize: '160%', textAlign: 'center'}}><i className="fa fa-spinner fa-spin" aria-hidden="true"></i></div>;

		const viewProductTags = this.props.viewProductTags || false;

		const productkeySuffix = (productViewMode? productViewMode:"defaultView") + "-" + (this.props.showSlider? "inslider": "inlist") + "-" + (title? title: "NA");
		const thumbnails = products !== null? products.map((p, i) => {
									let key = "Product-"+p.productType+"-"+p.id+"-"+productkeySuffix;

									if(this.props.flattenProductImages === true)
										key += "-"+p.productImages[0];

									return <ProductDesignThumbnail product={p} hrefParams={this.props.flattenProductImages === true? {"sc_img": p.productImages[0]}: null} productViewMode={productViewMode} viewProductTags={viewProductTags} key={key} />;
							}): [1,2,3,4].map(v => <ProductDesignThumbnail product={null} productViewMode={productViewMode} key={"ProductLoader-"+v} />);

		if(this.props.showSlider)
			return <ProductSlider title={title} productViewMode={productViewMode} autoplay={this.props.autoplay || false}
									navigator={this.props.navigator || "dots"} id={this.props.id} infinite={this.props.infinite || false}>
								{thumbnails}
					</ProductSlider>

		const emptyMsg = this.props.emptyMsg? this.props.emptyMsg: "No Products Found";

		return <InfiniteScroll
					pageStart={0}
				    loadMore={this.loadFunc.bind(this)}
				    hasMore={hasMore}
				    loader={loadMoreLoader}>
					{title &&
						<Title title={title} />
					}

					<div className="flexRow" style={{margin: '0 -5px'}} id={this.props.id}>
						{thumbnails}
					</div>

					{
						products !== null && products.length === 0 &&
						<div style={{fontSize: "220%", textAlign: "center", margin: "20px 0", color: "#757474"}}>
							<i className="fa fa-minus-circle" aria-hidden="true"></i> {emptyMsg}
						</div>
					}

				</InfiniteScroll>
	}
}

export default ProductList;


// WEBPACK FOOTER //
// ./src/views/product/ProductList.js